import { render } from "./UiCheckbox.vue?vue&type=template&id=07b77e44&ts=true"
import script from "./UiCheckbox.vue?vue&type=script&lang=ts"
export * from "./UiCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__